import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["passengers"]): number =>
	item?.[0]?.customer?.counters?.total || 0;

export default cellProcessing;
